import React from "react";

const DashboardCard = (props) => {
    const {design, name, val, key} = props;
    return (
        <div className="col-xl-3 col-sm-6 py-2" key={key}>
         <div className={design}>
            <h6 className="text-uppercase ml-2">{name}</h6>
            <span className="display-4sss ml-2 title">{val}</span>
        </div>
      </div>
    )
}

export default DashboardCard;